import React, { useContext } from 'react';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import { Stack, Button } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { ModalContext } from '../../contexts/modal';
import { toPersianDate, toPersianNumber } from '../../utils/helpers';
import { useGetInvoices } from '../../api/hooks/sales';
import InvoiceDetails from './invoice-details';

export default function InvoicesTable() {
  // const [page, setPage] = React.useState(0);
  const { data: invoices } = useGetInvoices(true, 0);
  return (
    <Paper variant="outlined" sx={{ width: '100%' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {invoices?.map(toFlatPropertyMap)?.map((row, i) => {
              return (
                <TableRow hover tabIndex={-1} key={i}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.format ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

const columns = [
  {
    id: 'number',
    label: 'شماره',
    minWidth: 70,
    format: toPersianNumber,
  },
  { id: 'seller', label: 'فروشنده', minWidth: 70 },
  { id: 'buyer', label: 'خریدار', minWidth: 70 },
  { id: 'createdAt', label: 'تاریخ ثبت', minWidth: 70, format: toPersianDate },
  // { id: 'status', label: 'وضعیت', minWidth: 70, format: (s) => DICTIONARY[s] },
  {
    id: 'id',
    label: 'جزئیات',
    minWidth: 70,
    format: (id) => {
      const { setOpen, setContent, setTitle } = useContext(ModalContext);

      function openLabelingModal() {
        setTitle('جزئیات سفارش');
        setContent(<InvoiceDetails id={id} onClose={() => setOpen(false)} />);
        setOpen(true);
      }

      return (
        <Stack sx={{ width: '100%' }} direction="row" justifyContent="space-around">
          <Button endIcon={<OpenInNewIcon />} onClick={openLabelingModal}>
            تحویل
          </Button>
        </Stack>
      );
    },
  },
];

function toFlatPropertyMap(obj) {
  const keySeparator = '.';
  const flattenRecursive = (obj, parentProperty, propertyMap = {}) => {
    for (const [key, value] of Object.entries(obj)) {
      const property = parentProperty ? `${parentProperty}${keySeparator}${key}` : key;
      if (value && typeof value === 'object') {
        flattenRecursive(value, property, propertyMap);
      } else {
        propertyMap[property] = value;
      }
    }
    return propertyMap;
  };
  return flattenRecursive(obj);
}
